import React from 'react';
import Square from '../components/Square';
import { Container, Navbar, YourChoose, PodpiszPls } from './styled/WeFightStyled';
import { connect } from 'react-redux';

const WeFight = ({ messageArray }) => {

    return (
        <div>
            <Navbar>
                <YourChoose>TWÓJ GŁOS SIĘ LICZY</YourChoose>
                <PodpiszPls>
                    Podpisując petycję przyłączasz się do ruchu osób broniących praw człowieka w szczególności kobiet oraz działających na rzecz przeciwdziałania przemocy i dyskryminacji ze względu na płeć.
               </PodpiszPls>
            </Navbar>
            <Container>
                {messageArray.map((item, i) => {
                    return (
                        <div key = {i}>
                            <Square number = {item.number} message = {item.message}/>
                        </div>
                    )
                })}
            </Container>
        </div>
    )
}

const mapStateToProps = (state) => ({
    messageArray: state.messageReducer.messageArray
})

export default connect(mapStateToProps, null)(WeFight);